module.exports = __webpack_public_path__ + "static/media/TT-Commons-Regular.ae5bbab3.otf";